import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListCategoriesQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Category',
  props: {
    categoryId: {
      type: Number,
      required: false,
      default: function _default() {
        return null;
      }
    },
    excludeSystemCategories: {
      type: Boolean,
      required: false,
      default: function _default() {
        return false;
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var search = ref('');
    var offset = ref(0);
    var limit = ref(100);

    // IDs of categories reserved for internal/system use.
    // When excludeSystemCategories is true, these will be hidden from the dropdown.
    var systemCategoryIds = [28];
    var variables = computed(function () {
      return {
        input: {
          text: search.value,
          onlyRootElements: true
        },
        offset: offset.value,
        limit: limit.value
      };
    });
    var _useListCategoriesQue = useListCategoriesQuery(variables),
      categoryResult = _useListCategoriesQue.result,
      categoryLoading = _useListCategoriesQue.loading,
      refetch = _useListCategoriesQue.refetch;
    var categoryItems = computed(function () {
      var _categoryResult$value;
      if (!((_categoryResult$value = categoryResult.value) !== null && _categoryResult$value !== void 0 && _categoryResult$value.listCategories)) {
        return [];
      }
      var rootCategories = categoryResult.value.listCategories;
      // Build flat grouped items: root categories as headers, their subcategories as selectable items
      // Vuetify 2 format: [{ header: 'Group' }, { text: 'Item', value: 1 }, ...]
      var groupedItems = [];
      rootCategories.forEach(function (root, index) {
        var subcategories = root.subcategories || [];
        if (subcategories.length > 0) {
          // Add divider before each group except the first
          if (index > 0) {
            groupedItems.push({
              divider: true
            });
          }
          // Add header for the root category
          groupedItems.push({
            header: root.label
          });
          // Add subcategories as selectable items (only children can be selected)
          subcategories.forEach(function (subcategory) {
            var _subcategory$id;
            var id = (_subcategory$id = subcategory === null || subcategory === void 0 ? void 0 : subcategory.id) !== null && _subcategory$id !== void 0 ? _subcategory$id : undefined;
            if (props.excludeSystemCategories && id !== undefined && systemCategoryIds.includes(id)) {
              return;
            }
            groupedItems.push({
              text: subcategory.label,
              value: id
            });
          });
        }
      });
      return groupedItems;
    });
    function onScroll(event) {
      var bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;
      if (bottom && !categoryLoading.value) {
        offset.value += limit.value;
        refetch(variables.value);
      }
    }
    return {
      __sfc: true,
      props: props,
      search: search,
      offset: offset,
      limit: limit,
      systemCategoryIds: systemCategoryIds,
      variables: variables,
      categoryResult: categoryResult,
      categoryLoading: categoryLoading,
      refetch: refetch,
      categoryItems: categoryItems,
      onScroll: onScroll
    };
  }
});